import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/storage'
import 'firebase/auth'

const firebaseConfig = process.env.VUE_APP_FIREBASE_CONFIG ? JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG) : {
	apiKey: 'AIzaSyBMUYpQJnHRNMXoUrF2g7w95LAwO2kVMUI',
	authDomain: 'somar-app.firebaseapp.com',
	databaseURL: 'https://somar-app.firebaseio.com',
	projectId: 'somar-app',
	storageBucket: 'somar-app.appspot.com',
	messagingSenderId: '270709304961',
	appId: '1:270709304961:web:ca6e81c79d1cd879326780',
	measurementId: 'G-Y3WCQ15FZR',
}

firebase.initializeApp(firebaseConfig)

const analytics = firebase.analytics()
analytics.setAnalyticsCollectionEnabled(process.env.NODE_ENV === 'production')

const storage = firebase.storage()
const auth = firebase.auth()

export {
	analytics,
	storage,
	auth,
}
